import { ErrorMessage, Field, Form, Formik } from 'formik'
import React, { useEffect, useState } from 'react'
import { Oval } from 'react-loader-spinner';
import * as yup from 'yup'
import { enregistrercommission } from '../../services/parametres/commission';
import { rechercheroperateurparpays } from '../../services/parametres/operateur';
import { rechercherpays } from '../../services/parametres/pays';
import { useTranslation } from 'react-i18next';

function AjoutCommission(props) {
    const { t } = useTranslation();
    const [loading, setloading] = useState(false);
    const [messageError, setmessageError] = useState("");
    const [listePays, setlistePays] = useState([])
    const [listeOperateur, setlisteOperateur] = useState([])
    const [isCommissionDefault, setisCommissionDefault] = useState(false)
    let [paysSelected, setpaysSelected] = useState("");

    let initialValues = {
        id : props.data.id !== undefined ? props.data.id : "",
        pays_id: (props.data.pays !== null && props.data.pays !== undefined ) ? props.data.pays.id : "",
        operateurMobileMoney_id: props.data.operateurMobileMoney_id !== undefined ? props.data.operateurMobileMoney_id : "",
        defaut: props.data.defaut !== undefined ? props.data.defaut : false,
        typeCommission: props.data.typeCommission !== undefined ? props.data.typeCommission : "",
        valeur: props.data.valeur !== undefined ? props.data.valeur : ""

    }

    const validationValuesSchema = yup.object().shape({
        typeCommission: yup.string().required(t('settings.commission.modal.errors.commissionTypeRequired')),
        valeur: yup.number().required(t('settings.commission.modal.errors.valueRequired'))
        })

    const afficherListePays = () => {
        rechercherpays().then((res) => {
            setlistePays(res.data.donnee);
        })
    }

    const optionListOperateur = listeOperateur.map((item, index) => (
        <option key={index} value={item.id}>{item.designation} | {item.id}</option>
    ));

    const optionListPays = listePays.map((item) => (
        <option key={item.id} value={item.id}>{item.designation}</option>
    ));

    const handleOnchangeIsDefault = () => {
        setisCommissionDefault(!isCommissionDefault);
    }

    const afficherOperateurs = (id) => {
        rechercheroperateurparpays(id).then((res) => {
            setlisteOperateur(res.data.donnee);
        })
    }

    const handlePays = (value) => {
        props.data.defaut !== undefined && setisCommissionDefault(props.data.defaut);
        paysSelected = value;
        setpaysSelected(paysSelected);
        value !== "" ? afficherOperateurs(value) : setlisteOperateur([]);
    }


    useEffect(() => {
        afficherListePays();
    }, []);

    useEffect(() => {
        (props.data.pays !== null && props.data.pays !== undefined) && handlePays(props.data.pays.id)
    }, [props.data.pays])

    

    const handleOnSubmitCommission = (values) => {
       setloading(true)
        values.defaut = isCommissionDefault;
        values.pays_id = paysSelected
        if (isCommissionDefault) {
            values.operateurMobileMoney_id = "";
        }
        enregistrercommission(values).then((res)=>{
            setloading(false);
            props.affichercommission();
            document.getElementById("fermer").click();
        }).catch((error)=>{
            setloading(false);
            console.log(error.response.data);
            error.response.data.donnee.pays_id !== undefined && setmessageError(t('settings.commission.modal.errors.countryRequired'));
            error.response.data.donnee.operateurMobileMoney_id !== undefined && setmessageError(error.response.data.donnee.operateurMobileMoney_id);
            ((typeof error.response.data.donnee ) === "string") && setmessageError(error.response.data.donnee);
        })
    }

    return (
        <div className="modal fade" id="ajoutcommission" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1} aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content blueSkanpay">
                    <div className="modal-header text-white">
                        <h5 className="modal-title" id="staticBackdropLabel">{t('settings.commission.modal.title')}</h5>
                        <button type="button" className="bg-danger btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>

                    <Formik
                        initialValues={initialValues}
                        enableReinitialize
                        validationSchema={validationValuesSchema}
                        onSubmit={handleOnSubmitCommission}
                    >
                        {({ resetForm }) => (

                            <Form>
                                <div className="modal-body bg-white">
                                    {messageError !== "" && <p className='text-danger'><i className='fa fa-exclamation-triangle'></i> {messageError}</p>}

                                    <div className='mb-3'>
                                        <div className="form-check form-switch">
                                            <input className="form-check-input" onChange={(e) => handleOnchangeIsDefault(e)} checked={isCommissionDefault} name="isDefaultCommission" type="checkbox" id="isDefaultCommission" />
                                            <label className="form-check-label" htmlFor="isDefaultCommission">{t('settings.commission.modal.defaultCommission')}</label>
                                        </div>
                                    </div>
                                            <div className='mb-3'>
                                                <label htmlFor="pays_id" className='form-label'>{t('settings.commission.modal.country')}</label>
                                                <Field component="select" onChange={(e)=>handlePays(e.target.value)} value={paysSelected} name="pays_id" className='form-select' id="pays_id">
                                                    <option value="">{t('settings.commission.modal.selectCountryPlaceholder')}</option>
                                                    {optionListPays}
                                                </Field>
                                            </div>
                                    {
                                        !isCommissionDefault && 
                                            <div className='mb-3'>
                                                <label htmlFor="operateur_mobile_money_id" className='form-label'>{t('settings.commission.modal.operator')}</label>
                                                <Field component="select" name="operateurMobileMoney_id" className='form-select' id="operateur_mobile_money_id">
                                                    <option value="">{t('settings.commission.modal.selectOperatorPlaceholder')}</option>
                                                    {optionListOperateur}
                                                </Field>
                                                <p className='text-danger'><ErrorMessage name="operateurMobileMoney_id"></ErrorMessage></p>
                                            </div>
                                        
                                    }

                                    <div className='mb-3'>
                                        <label htmlFor="typeCommission" className='form-label'>{t('settings.commission.modal.commissionType')}</label>
                                        <Field component="select" className='form-control' id='typeCommission' name="typeCommission" >
                                            <option value="">{t('settings.commission.modal.selectCommissionType')}</option>
                                            <option value="FIXE">{t('settings.commission.modal.fixed')}</option>
                                            <option value="POURCENTAGE">{t('settings.commission.modal.percentage')}</option>
                                        </Field>
                                        <p className='text-danger'><ErrorMessage name="typeCommission"></ErrorMessage></p>
                                    </div>
                                    <div className='mb-3'>
                                        <label htmlFor="valeur" className='form-label'>{t('settings.commission.modal.value')}</label>
                                        <Field className="form-control" name="valeur" id="valeur" type="number"/>
                                        <p className='text-danger'><ErrorMessage name="valeur"></ErrorMessage></p>
                                    </div>
                                </div>
                                <div className="modal-footer bg-white">
                                    <button type="button" id='fermer' onClick={()=>{resetForm(); setpaysSelected(""); setmessageError("")}} className="btn btn-sm btn-secondary" data-bs-dismiss="modal">{t('settings.commission.modal.close')}</button>
                                    <Oval width={30} height={30} color="#344b7b" visible={loading} />
                                    {!loading && <button type="submit" className="btn btn-sm text-white blueSkanpay">{t('settings.commission.modal.save')}</button>}
                                </div>
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </div >
    )
}

export default AjoutCommission